// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_DeleteOrigemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/origens/deleteOrigem
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Origens_DeleteOrigemResponseDados = null;

export type Origens_DeleteOrigemResponse = ApiResponse<Origens_DeleteOrigemResponseDados>;

registerResponseContract('Origens_DeleteOrigemResponse', {})
